import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { ReactComponent as Logo } from 'svg/logo.svg';

import './style.css';

const HeaderSimple = ({ children }) => {
  return (
    <header className="header-simple">
      <div className="header-wrapper wrapper-full">
        <NavLink to="/">
          <Logo className="logo" />
        </NavLink>
        {children}
      </div>
    </header>
  );
};

HeaderSimple.propTypes = {
  children: PropTypes.node,
};

HeaderSimple.defaultProps = {
  children: null,
};

export default HeaderSimple;
